import vars from '../helpers';

import {animatioтScheme} from './chapterAnimation/animationGraphick';
import {navigation, showNavigation} from './chapterAnimation/navigation';
import {parallax} from './chapterAnimation/parallax';
import {scrollTriggerTitle, subtitle} from './chapterAnimation/subtitle';
import {animateGradient, animateHighlight} from './chapterAnimation/animateHighlight';
import {horizontalScroll} from './chapterAnimation/horizontalScroll';
import {initAnimationPartTwo} from './chapterAnimation/scheme/2-1';
import {pitures} from './chapterAnimation/scheme/pictures';
import {initAnimationPartThree} from './chapterAnimation/scheme/3-1';
import {figureParallax} from './chapterAnimation/figureParallax';
import chapterFixed from './chapterAnimation/scheme/chapter-fixed';
import loadSvg from "./loadSvg";
import helpers from "../helpers";

const $dataChapters = [...document.querySelectorAll('.page[data-chapters]:not(.home)')];

let resized = false;

const refresAfterResize = (parent) => {
	if (!resized) {
		return;
	}

	if (!parent.refreshed) {
		parent.refreshed = true;

		const chaptersIndex = parent.dataset.chapters;

		[...ScrollTrigger.getAll()].forEach((currentST) => {
			if (currentST.trigger && currentST.trigger.closest(`.page[data-chapters="${chaptersIndex}"]`)) {
				currentST.refresh();
			}
		});
	}

	if ($dataChapters.filter(($dcc) => $dcc.refreshed).length === $dataChapters.length) {
		resized = false;
	}
};

const resize = () => {
	resized = true;

	$dataChapters.forEach(($dataChaptersCurrent) => {
		$dataChaptersCurrent.refreshed = false;
	});
};

const init = () => {
	navigation();

	vars.$document.on('show-animation', (event, id) => {
		const parent = document.querySelector(`.page[data-chapters="${id}"]`);
		const isInited = parent.dataset.initAnimation;

		figureParallax(parent);
		refresAfterResize(parent);

		if (isInited) {
			return;
		}

		parent.setAttribute('data-init-animation', true);

		subtitle(parent);
		showNavigation();
		parallax(parent);
		scrollTriggerTitle(parent);
		horizontalScroll(parent);
		animateGradient(parent);

		chapterFixed.create();

		if (id === 1) {
			animatioтScheme(parent);

		} else if (id === 2) {
			if (helpers.isMobile()) {
				setTimeout(loadSvg.init, 1000);
			} else {
				loadSvg.init();
			}

			animateHighlight(document.querySelector('.chapters--2 .chapter-container--gradient'));

			if ($(window).width() >= 1024) {
				pitures({
					img: '.chapter__scheme-2-2.for-desktop .scheme-2-2',
					endTrigger: '.chapter__decor',
					end: 'top 100%',
				});
			} else {
				pitures({
					img: '.chapter__scheme-2-2.for-mobile .scheme-2-2',
					endTrigger: '.chapter__decor',
					end: 'top 100%',
				});
			}

			if ($(window).width() >= 1024) {
				pitures({
					img: '.chapter__scheme-2-3.for-desktop .scheme-2-3',
					endTrigger: '.chapter-container--gradient .chapter__cover--big',
					end: 'top-=10% 100%',
				});
			} else {
				pitures({
					img: '.chapter__scheme-2-3.for-mobile .scheme-2-3',
					endTrigger: '.chapter-container--gradient .chapter__top',
					end: 'top-=10% 100%',
				});
			}

			initAnimationPartTwo();

			chapterFixed.update();

			vars.$document.trigger('bg-play', '.chapter-fixed .chapter-glare');
		} else if (id === 3) {
			animateHighlight(document.querySelector('.chapters--3 .chapter-container--gradient'), false);

			initAnimationPartThree();
		} else {
			vars.$document.trigger('bg-destroy', '.chapter-fixed .chapter-glare');
		}
	});
};

export default {
	init,
	resize,
};
